import BaseService from './BaseService';

class BillingAccountService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/account/billingAccount";
	}


	getNextInvoiceDate(ca) {
		let url = this.serviceUrl + '?billingAccountCode=' + ca.code;
		return this.opencellAPI.callApi(url);
	}

	getBillingCycle(billingCycleCode){
		let url = "/api/rest/billingCycle?billingCycleCode=" + billingCycleCode;
		return this.opencellAPI.callApi(url);
	}

	getCalendar(calendarCode){
		let url = "/api/rest/calendar?calendarCode=" + calendarCode;
		return this.opencellAPI.callApi(url);
	}
}

const billingAccountService = new BillingAccountService();

export default billingAccountService;



// WEBPACK FOOTER //
// ./src/opencell/services/BillingAccountService.js